import { render, staticRenderFns } from "./client-modal.vue?vue&type=template&id=fe7be37a&scoped=true&"
import script from "./client-modal.vue?vue&type=script&lang=ts&"
export * from "./client-modal.vue?vue&type=script&lang=ts&"
import style0 from "./client-modal.vue?vue&type=style&index=0&id=fe7be37a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe7be37a",
  null
  
)

component.options.__file = "client-modal.vue"
export default component.exports